import React from 'react';
import { InlineEditStateless } from './InlineEditStateless';
export const InlineEdit = React.memo(React.forwardRef((props, ref) => {
    const [isEditing, setIsEditing] = React.useState(false);
    const enterEditingMode = () => setIsEditing(true);
    const exitEditingMode = () => setIsEditing(false);
    const onConfirm = () => {
        exitEditingMode();
        props.onConfirm();
    };
    const onCancel = () => {
        exitEditingMode();
        props.onCancel();
    };
    return (React.createElement(InlineEditStateless, Object.assign({ ref: ref, isEditing: isEditing }, props, { onEditRequested: enterEditingMode, onConfirm: onConfirm, onCancel: onCancel })));
}));
//# sourceMappingURL=InlineEdit.js.map